import React from "react";
import ComponentCard from "../../../components/common/ComponentCard";
import PartnerListComponent from "../../../components/slider/PartnerListComponent";
import PageMeta from "../../../components/common/PageMeta";

const PartnersList = () => {

    return (
        <>
            <PageMeta title="Danh sách đối tác" description="Danh sách đối tác"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <PartnerListComponent />
                </ComponentCard>
            </div>
        </>
    );
};

export default PartnersList;
